<template>
  <div class="modal-overlay flex justify-center items-center min-h-screen bg-gray-100">
    <div
      class="modal-content shadow-lg rounded-lg p-6 max-w-lg w-full sm:max-w-md sm:p-4 flex flex-col items-center relative"
      @click.stop>
      <!-- Close Button -->
      <button class="close-button" @click="closeModal">
        <i class="fas fa-times"></i>
      </button>

      <!-- Content -->
      <!-- <div class="subscribe-image">
        <img src="../../assets/man-newsletter.png" alt="Newsletter" class="w-full sm:w-2/3">
      </div> -->
      <br>
      <div class="text-container text-white mt-4 text-left w-full sm:w-auto">
        <h2 class="font-bold header">Anmäl dig till Eventstadens nyhetsbrev och få:</h2>
        <!-- <p class="mt-2 text-xs sm:text-sm">Vill du vara först med att få reda på:</p> -->
        <p class="m-0 p-0 leading-tight text">✅ Förhandsinformation om unika event</p>
        <p class="m-0 p-0 leading-tight text">✅ Exklusiva erbjudanden och rabatter</p>
        <p class="m-0 p-0 leading-tight text">✅ VIP-inbjudningar</p>

        <br>
        <p class="m-0 p-0 leading-tight text">✅ Gratis överraskningar från våra samarbetspartners</p>

        <!-- <p class="mt-4 font-bold text-xs sm:text-sm">Anmäl dig till Eventstadens nyhetsbrev och få:</p>
        <p class="m-0 p-0 leading-tight text-xs sm:text-sm">🎉 Exklusiva erbjudanden</p>
        <p class="m-0 p-0 leading-tight text-xs sm:text-sm">📌 Personliga tips</p>
        <p class="m-0 p-0 leading-tight text-xs sm:text-sm">💡 Inspiration direkt i din inkorg</p> -->
        <br>
        <!-- <p class="mt-4 font-semibold text-xs sm:text-sm">Anmäl dig nu och börja utforska Sverige på ett nytt sätt!</p> -->
        <p class="text-gray-300 text">Missa inget - signa upp idag och upplev mer!</p>
      </div>

      <!-- Input Fields -->
      <div class="mt-4 input-container w-full max-w-xs">
        <b-input-group class="name-bar">
          <b-input-group-prepend is-text>
            <i class="fas fa-user"></i>
          </b-input-group-prepend>
          <b-form-input type="text" class="name-input" v-model="name" placeholder="Ditt namn" />
        </b-input-group>

        <b-input-group class="search-bar mt-2">
          <b-input-group-prepend is-text>
            <i class="fas fa-envelope"></i>
          </b-input-group-prepend>
          <b-form-input type="email" class="email-input" v-model="email" placeholder="E-postadress" />
        </b-input-group>
      </div>
      <div v-if="!isMobile" class="flex w-full mt-4 gap-2 self-start">
        <action-button class="send-button" label="Skicka" variant="success" :disabled="!isValidEmail"
          :action="subscribe" />
      </div>
      <div v-if="isMobile" class="flex w-full mt-4 gap-2 self-start">
        <action-button class="send-button" label="Skicka" variant="success" :disabled="!isValidEmail"
          :action="subscribe" />
      </div>
      <p v-if="message" class="text-white mt-2">{{ message }}</p>
    </div>
  </div>
</template>


<script>
import AxiosInstance from "../../api/axios";
import localStorageService from "../../localStorageService/localStorageService.js";
import ActionButton from "../../components/Buttons/actionButton.vue";

export default {
  name: "SubscribeEmail",
  components: {
    ActionButton,
  },
  data() {
    return {
      name: "",
      email: "",
      message: ""
    };
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isValidEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    hideSubscribe() {
      localStorageService.set("hide-subscribe", "true");
      this.closeModal();
    },
    async subscribe() {
      if (!this.email) {
        this.message = "Please enter a valid email.";
        return;
      }

      try {
        const response = await AxiosInstance.post("users/mailchimp/subscribe", {
          name: this.name,
          email: this.email
        });
        console.dir(response);
        if (response.data.success) {
          this.hideSubscribe();
        }

      } catch (error) {
        // console.dir("2");
        // this.message = response.data.message;
      }
    }
  }
};
</script>

<style>
.header {
  font-size: 16px !important;
}

.text {
  font-size: 14px !important;
}

.modal-content {
  background-color: #141313 !important;
  border: none !important;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  align-items: stretch;
  text-align: left;
  /* Ensure text is aligned left */
  padding-bottom: 10px;
  width: 100%;
  position: relative;
  max-width: 450px;
  /* Base modal width */
}

/* Mobile-friendly adjustments */
@media (max-width: 640px) {

  .hide-button,
  .send-button {
    font-size: 11px !important;
    padding: 10px !important;
    width: 100px !important;
    /* flex: 1; */
  }

  /* .flex {
    display: flex;
  } */

  .header {
    font-size: 13px !important;
  }

  .text {
    font-size: 11px !important;
  }
}

/* Close button styling */
.close-button {
  position: absolute;
  top: 0px;
  right: 0px;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.text-container {
  padding-left: 13px;
  padding-right: 13px;
}

.close-button:hover {
  color: white;
}

/* Ensure buttons are positioned correctly */
.send-button,
.hide-button {
  width: auto;
  /* Allow buttons to shrink to fit their content */
}

.hide-button {
  margin-top: 0px;
  margin-left: 13px !important;
}

.send-button {
  margin-top: 0px;
  margin-right: 13px !important;
}

/* Container for buttons to be spread left and right */
.flex {
  display: flex;
}

/* .justify-between {
  justify-content: space-between;
  width: 100%;
} */

.input-container {
  width: 100%;
  max-width: 400px;
}

/* Ensure image and text scales well on small screens */
/* .subscribe-image img {
  max-width: 100%;
  height: auto;
} */
</style>
